import { render, staticRenderFns } from "./ShopSelectionSection.vue?vue&type=template&id=033ae630&"
import script from "./ShopSelectionSection.vue?vue&type=script&lang=js&"
export * from "./ShopSelectionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports